import homeBg from "../../assets/images/home-bg.svg";
import aiMeasureLogo from '../../assets/images/logos/ai-measure-logo-black.svg'
import toyoshimaLogo from '../../assets/images/logos/toyoshima-black.svg'
import openEyeIcon from '../../assets/images/icons/eye-open.svg'
import closeEyeIcon from '../../assets/images/icons/eye-close.svg'
import { useCallback, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PATH_INFO } from "../utils/helper";
import { UpdateAuthContext } from "../../context/authContext";

export function Login() {
  const { login } = useContext(UpdateAuthContext)

  const navigate = useNavigate()

  const [userInfo, setUserInfo] = useState({ email: '', password: '' })
  const [isShow, setIsShow] = useState(false)
  const [isSuccess, setIsSuccess] = useState(true)

  const onToggleShow = useCallback(() => {
    setIsShow((prev) => !prev)
  }, [])

  const onLogin = useCallback(async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    const result = await login(userInfo)
    if (result) {
      navigate(PATH_INFO.HOME.PATH)
    } else {
      setIsSuccess(false)
    }
  }, [navigate, login, userInfo])

  return (
    <div
      className="flex items-center justify-center h-screen "
      style={{ backgroundImage: `url(${homeBg})` }}
    >
      <div className="flex w-[1142px] h-[914px] rounded-[10px] overflow-hidden">
        <div className="flex flex-col justify-between items-center p-[50px] bg-[#F3F3F3] w-full">
          <p className="font-hiragino text-[24px]">WELLCOME AI MEASURE!</p>
          <img src={aiMeasureLogo} alt="logo" className="w-[217px]" />
          <img src={toyoshimaLogo} alt="logo" className="w-[151px]" />
        </div>
        <div className="relative flex flex-col items-center bg-white w-full font-[Poppins] pt-[226px]">
          <p className="font-bold text-[20px] pb-[90px]">Log in</p>
          <form className="flex flex-col">
            <div className={`flex flex-col mb-[20px] border-b-[1px] ${isSuccess ? 'border-black' : 'border-red-600'}`}>
              <label className="text-[16px]">Email(*)</label>
              <input
                type="text"
                className="pl-[10px] py-[7px] outline-none font-normal"
                value={userInfo.email}
                onChange={(e) => setUserInfo((prev) => ({ ...prev, email: e.target.value }))}
              />
            </div>
            <div className="flex flex-col">
              <label className="text-[16px]">Password</label>
              <div className={`relative w-full border-b-[1px] ${isSuccess ? 'border-black' : 'border-red-600'}`}>
                <input
                  type={isShow ? 'text' : 'password'}
                  className='pl-[10px] py-[7px] outline-none w-[350px]'
                  value={userInfo.password}
                  onChange={(e) => setUserInfo((prev) => ({ ...prev, password: e.target.value }))}
                />
                <div onClick={onToggleShow} className="absolute right-[12px] bottom-1/2 translate-y-1/2 hover:cursor-pointer">
                  {isShow ? (
                    <img src={openEyeIcon} alt="open" className="w-[22px] h-[17px]" />
                  ) : (
                    <img src={closeEyeIcon} alt="close" className="w-6 h-[21px]" />
                  )}
                </div>
              </div>
            </div>
            <button
              className="flex items-center justify-center w-[399px] h-[73px] bg-black text-white rounded-[10px] font-bold mt-[190px]"
              onClick={onLogin}
            >login now</button>
          </form>
          <div className="absolute flex justify-center bottom-[50px] w-[175px] h-[31px] border-b-[1px] border-black">
            <button className="text-[14px] font-medium">Fogot your password?</button>
          </div>
        </div>
      </div>
    </div>
  );
};